/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner. Pass body to block the whole page.
 */
function addSpinner($target) {
  const $sorSpinnerVeil = $('<div class="spinner-container"><div class="underlay"></div></div>');
  $sorSpinnerVeil.append('<div class="sor-spinner"><div class="sor-dot1"></div><div class="sor-dot2"></div></div>');
  $sorSpinnerVeil.css('z-index', '100000'); // smart order refill modification
  if ($target.get(0).tagName === 'IMG') {
    $target.after($sorSpinnerVeil);
    $sorSpinnerVeil.css({ width: $target.width(), height: $target.height() });
    if ($target.parent().css('position') === 'static') {
      $target.parent().css('position', 'relative');
    }
  } else {
    $target.append($sorSpinnerVeil);
    if ($target.css('position') === 'static') {
      $target.parent().css('position', 'relative');
      $target.parent().addClass('veiled');
    }
    if ($target.get(0).tagName === 'BODY') {
      $sorSpinnerVeil.find('.sor-spinner').css('position', 'fixed');
    }
  }
  $sorSpinnerVeil.click(function (e) {
    e.stopPropagation();
  });
}

/**
 * Remove existing spinner
 * @param  {element} $sorSpinnerVeil - jQuery pointer to the veil element
 */
function removeSpinner($sorSpinnerVeil) {
  if ($sorSpinnerVeil.parent().hasClass('veiled')) {
    $sorSpinnerVeil.parent().css('position', '');
    $sorSpinnerVeil.parent().removeClass('veiled');
  }
  $sorSpinnerVeil.off('click');
  $sorSpinnerVeil.remove();
}

// element level spinner:
$.fn.sorSpinner = function () {
  const $element = $(this);
  const Fn = function () {
    this.start = function () {
      if ($element.length) {
        addSpinner($element);
      }
    };
    this.stop = function () {
      if ($element.length) {
        const $sorSpinnerVeil = $('.spinner-container');
        removeSpinner($sorSpinnerVeil);
      }
    };
  };
  return new Fn();
};

// page-level spinner:
$.sorSpinner = function () {
  const Fn = function () {
    this.start = function () {
      addSpinner($('body'));
    };
    this.stop = function () {
      removeSpinner($('.spinner-container'));
    };
    this.isExist = function () {
      return $('.spinner-container').length > 0;
    };
  };
  return new Fn();
};
